'use es6';

import I18n from 'I18n';
export function setDocumentTitle(pageTitle) {
  if (!window || !window.document) {
    return;
  }
  const appTitle = I18n.text('FileManagerDashboard.app.htmlTitle');
  const title = pageTitle ? `${pageTitle} | ${appTitle}` : appTitle;
  window.document.title = title;
}